const $ = jQuery.noConflict();

class AlertBar {
    constructor() {
        this.alertBar = document.querySelector('.alert-bar');
    }
    init() {
        if ( null !== this.alertBar ) {
            this.alertBar.querySelector('.alert-bar__close').addEventListener( 'click', this.closeAlert.bind(this) );
        }

        this.setHeight()
    }
    setHeight() {
        if ( null !== this.alertBar ) {
            document.documentElement.style.setProperty('--alert-height', this.alertBar.offsetHeight + "px");
        }
    }
    closeAlert() {
        this.alertBar.style.display = 'none';

        document.body.classList.remove('alert-visible');

        // Set cookie
        var timeToAdd = 1000 * 60 * 60 * 24;
        var date = new Date();
        var expiryTime = parseInt(date.getTime()) + timeToAdd;
        date.setTime(expiryTime);
        var utcTime = date.toUTCString();
        document.cookie = "alert_closed=yes; expires=" + utcTime + ";";
    }
}

export default AlertBar;
